export default {
  DESCRIPTION: 0,
  TYPE: [
    { KEY: 0, VALUE: 'Depósito em conta' },
    { KEY: 1, VALUE: 'Utilização de crédito' },
  ],

  USAGE_TYPES: [
    { KEY: 0, ID: 'TOKEN', VALUE: 'TOKEN' },
    { KEY: 1, ID: 'TRANSPORT_CARD', VALUE: 'CARTÃO DE TRANSPORTE' },
    { KEY: 2, ID: 'EMV', VALUE: 'CARTÃO EMV' },
    { KEY: 3, ID: 'BUTTON', VALUE: 'BOTOEIRA' },
    { KEY: 4, ID: 'EXTERN', VALUE: 'ENTRADA EXTERNA' },
    { KEY: 5, ID: 'FACIAL', VALUE: 'Facial' },
  ],
  PAYMENT_TYPE: [
    { KEY: 'CREDIT_CARD_CLEAN', VALUE: 'CARTÃO DE CRÉDITO - NOVO' },
    { KEY: 'CREDIT_CARD', VALUE: 'CARTÃO DE CRÉDITO - EXISTENTE' },
    { KEY: 'BOLETO', VALUE: 'BOLETO' },
    { KEY: 'PIX', VALUE: 'PIX' },
    { KEY: 'MONEY', VALUE: 'DINHEIRO' },
    { KEY: 'VOUCHER', VALUE: 'VOUCHER' },
    { KEY: 'REQUISITION', VALUE: 'REQUISICÃO' },
    { KEY: 'FREE', VALUE: 'GRATUIDADE' },
    { KEY: 'POS_PAID', VALUE: 'POS-PAGO' },
    { KEY: 'EXTERNAL', VALUE: 'PAGAMENTO EXTERNO' },
    { KEY: 'DEBIT_CARD', VALUE: 'CARTÃO DE DEBITO' },
  ],
  SPECIAL_TRANSACTION_TYPES: [
    { KEY: 'balance.remove', VALUE: 'Estorno de Crédito' },
  ],
};
